import { DeleteOutlined, InboxOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu, Popconfirm, Space } from "antd";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Col, Progress, Row } from "reactstrap";
import { H6, Image, P } from "../../../../AbstractElements";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import "./CusClass.style.css";

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const CusClass = (props) => {
  const history = useNavigate();
  const logger = React.useContext(LoggerContext);
  const { item, onEdit } = props;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const startDay = moment(item?.start_date, "YYYY-MM-DD").format("DD");
  const startMonth = moment(item?.start_date, "YYYY-MM-DD").format("MMMM");
  const startYear = moment(item?.start_date, "YYYY-MM-DD").format("YY");
  const startDate = startMonth + " " + startDay + "," + startYear;
  const endDay = moment(item?.end_date, "YYYY-MM-DD").format("DD");
  const endMonth = moment(item?.end_date, "YYYY-MM-DD").format("MMMM");
  const endYear = moment(item?.end_date, "YYYY-MM-DD").format("YY");
  const endDate = endMonth + " " + endDay + "," + endYear;
  // const difference = moment(start_date)
  const handleMenuClick = (e) => {
    if (e.key === "5") {
      props.handleDelete(item?.id);
    } else if (e.key === "4") {
      history("/app/project/powo", { state: { id: item.id } });
    } else if (e.key === "3") {
      history("/app/project/budget", { state: { id: item.id } });
    } else if (e.key === "2") {
      history("/app/project/project-settings", { state: { id: item.id } });
    }
  };
  const menu = (
    <Menu
      items={[
        {
          key: "1",
          label: (
            <Popconfirm
              okText={"Yes"}
              cancelText={"No"}
              title={"Are you sure to delete?"}
              onConfirm={() => {
                props.handleDelete(item?.id);
              }}
            >
              <Button
                className="btn"
                size="small"
                icon={<DeleteOutlined />}
                danger
              >
                Delete
              </Button>
            </Popconfirm>
          ),
        },
        {
          key: "2",
          label: item?.is_archived ? (
            <Popconfirm
              okText={"Yes"}
              cancelText={"No"}
              title={"Are you sure you want to un-archive this project?"}
              onConfirm={() => {
                props.handleArchive(item?.id, false);
              }}
            >
              <Button className="btn" size="small" icon={<InboxOutlined />}>
                Un-Archive
              </Button>
            </Popconfirm>
          ) : (
            <Popconfirm
              okText={"Yes"}
              cancelText={"No"}
              title={"Are you sure you want to archive this project?"}
              onConfirm={() => {
                props.handleArchive(item?.id, true);
              }}
            >
              <Button className="btn" size="small" icon={<InboxOutlined />}>
                Archive
              </Button>
            </Popconfirm>
          ),
        },
      ]}
    />
  );

  function getProgressBarColor(item) {
    let poRaised = parseFloat(item?.po_raised).toFixed(2) ?? 0;
    let budget = parseFloat(item?.total_budget).toFixed(2) ?? 0;

    const percent = (parseFloat(poRaised / budget)?.toFixed(2) ?? 0) * 100;

    if (percent < 70) {
      return "";
    } else if (percent < 100) {
      return "warning";
    } else {
      return "danger";
    }
  }
  function numDifferentiation(value) {
    var val = Math.abs(value) ?? 0;
    if (val >= 10000000) {
      val = (val / 10000000 ?? 0).toFixed(2) + " Cr";
    } else if (val >= 100000) {
      val = (val / 100000 ?? 0).toFixed(2) + " Lakhs";
    }
    return val;
  }
  const goToProject = (project) => {
    const { dispatch } = props;

    logger.log(LogEvents.selectProject, {});
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "project",
        value: project,
      },
    });
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "projectSelected",
        value: true,
      },
    });
    history(`/project-dashboard/` + project?.id);
  };

  const getPercentSpent = () => {
    let poRaised = parseFloat(item?.po_raised ?? 0)?.toFixed(2) ?? 0;
    let budget = parseFloat(item?.total_budget ?? 0)?.toFixed(2) ?? 0;

    const percent = (
      (parseFloat(poRaised / budget ?? 0)?.toFixed(2) ?? 0) * 100
    ).toString();
    var percentString = percent.split(".")[0];
    if (poRaised == 0) {
      return 0;
    }
    return percentString;
  };
  return (
    <Col className="col-xxl-4" lg="6">
      <div className="project-box">
        <div
          onClick={() => {
            goToProject(item);
          }}
          style={{ cursor: "pointer" }}
        >
          <div>
            <Row className="d-flex justify-content-between">
              <Col className="col-10">
                <H6>
                  {item?.project_name} #{item?.id}
                </H6>
                {item?.project_code && (
                  <small className="text-color-grey">
                    {item?.project_code}
                  </small>
                )}
              </Col>
              <Col
                className="d-flex justify-content-end col-2"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div>
                  <Dropdown
                    overlay={menu}
                    placement="bottomRight"
                    arrow={{
                      pointAtCenter: true,
                    }}
                  >
                    <MoreOutlined style={{ fontSize: 20 }} />
                  </Dropdown>
                </div>
              </Col>
            </Row>
            <div className="media cus-class-details">
              <Space>
                <Image
                  attrImage={{
                    className: "img-20 me-1 rounded-circle",
                    src: `https://png.pngtree.com/png-vector/20190618/ourmid/pngtree-location-glyph-black-icon-png-image_1503424.jpg`,
                    alt: "",
                  }}
                />
                <div className="media-body">
                  <P>{item?.city}</P>
                </div>
              </Space>
              <span>{item?.contact_person}</span>
            </div>
          </div>
          {/* <div className="">
            <span className="d-flex align-items-center">
              <span style={{ fontSize: "18px" }}>
                {"Day " +
                  Math.ceil(
                    moment
                      .duration(
                        moment().diff(
                          moment(item?.start_date, "YYYY-MM-DD").startOf("day")
                        )
                      )
                      .asDays()
                  )}
              </span>
              <span
                className=""
                style={{ marginLeft: 5 }}
              >{`(${startDate} - ${endDate})`}</span>
            </span>
          </div> */}
          <Row className="details" style={{ marginTop: 10 }}>
            <Col xs="8">
              <span className="text-color-light-grey">{"Budget Spent"} </span>
            </Col>
            <Col xs="4"></Col>
            <Col xs="7">
              {" "}
              <span className="text-color-grey fw-bold">
                ({getPercentSpent(item)}% of{" "}
                {numDifferentiation(item?.total_budget)})
              </span>
            </Col>
            <Col xs="5">
              <span className="text-color-grey">
                PO's Raised:
                <span className=" fw-bold">{" " + item?.no_po_raised}</span>
              </span>
            </Col>
          </Row>
        </div>
        {/* <div className="my-2">
          <hr />
        </div> */}
        <Progress
          style={{
            height: "0.3rem",
          }}
          color={getProgressBarColor(item)}
          value={
            ((item?.po_raised ?? 0) / item?.total_budget)?.toFixed(2) * 100
          }
        />
      </div>
    </Col>
  );
};

export default connect(mapStateToProps)(CusClass);
